<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle d-block">Chamado</span>
        <d-row>
          <d-col cols="9" v-if="!editTitle">
            <h3 class="page-title" @click="changeTitle">{{ ticket.title }}</h3>
          </d-col>
          <d-col cols="9" class="page-title px-3" v-else>
            <d-input v-model="ticket.title" @blur.native="saveTitle"></d-input>
          </d-col>
          <d-col cols="3">
            <d-link class="btn btn-success text-white float-right " :to="{name: 'admin-ticket-new'}">Novo chamado</d-link>
          </d-col>
        </d-row>
      </d-col>
    </d-row>

    <!-- Content -->
    <ticket-comments-page ref="ticketForm" v-if="ticket"/>
  </d-container>
</template>

<script>
import { mapActions } from 'vuex';
import { cloneDeep } from '_utils';
import Events from '_utils/events';
import TicketCommentsPage from '_modules/ticket/components/TicketCommentsPage.vue';
import { _SAVE_MODEL_, _LOAD_MODEL_, MODEL } from '../components/TicketModel';

export default {
  name: 'ticket-comments',
  components: {
    TicketCommentsPage,
  },
  computed: {
    ticket() {
      const { ticketEdit } = this.$store.state.ticket;
      if (ticketEdit) {
        Events.$emit(_LOAD_MODEL_, ticketEdit);
        return ticketEdit;
      }
      return cloneDeep(MODEL);
    },
  },
  data() {
    return {
      editTitle: false,
      isTicketLogged: false,
    };
  },
  methods: {
    ...mapActions([
      'getTicket',
      'setToggle',
      'activeAlert',
      'updateTicket',
    ]),
    changeTitle() {
      this.editTitle = !this.editTitle;
    },
    getTicketModel() {
      this.getTicket(parseInt(this.$route.params.ticketId, Number));
    },
    saveTitle() {
      const ticket = {
        id: this.ticket.id,
        title: this.ticket.title,
        field: 'title',
      };
      this.updateTicket(ticket)
        .then(() => {
          this.activeAlert({ message: 'Título do chamado alterado com sucesso', theme: 'success' });
          this.editTitle = false;
        });
    },
  },
  mounted() {
    if (this.$route.params.ticketId) {
      this.getTicketModel();
    }
    Events.$on(_SAVE_MODEL_, () => {
      this.getTicketModel();
    });
  },
};
</script>

